import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { Contacts } from '../../components/Contacts';
import { IAgentCardPhone } from '../../types/agentCard';
import { PhoneContainer } from '../PhoneContainer';
import { selectCompany, selectIsContactsVisible } from 'shared/slices';

export const ContactsContainer = () => {
  const { ctPhoneNumber, skype, website, regionsNames, phones } = useSelector(selectCompany, shallowEqual);
  const isContactsVisible = useSelector(selectIsContactsVisible);

  const phonesNode = React.useMemo(() => {
    if (ctPhoneNumber) {
      return <PhoneContainer phone={ctPhoneNumber} />;
    }

    if (phones && phones.length) {
      return phones.map((phone: IAgentCardPhone) => (
        <PhoneContainer key={phone.number} phone={`${phone.countryCode}${phone.number}`} />
      ));
    }

    return null;
  }, [ctPhoneNumber, phones]);

  if (!isContactsVisible) {
    return <Contacts regionsNames={regionsNames?.join(', ')} phonesNode={null} skype={undefined} website={undefined} />;
  }

  return <Contacts phonesNode={phonesNode} skype={skype} website={website} regionsNames={regionsNames?.join(', ')} />;
};
